import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CONTACT, LOGO_WHITE } from "@/data";

export const LegalLayout = ({ title, updated, children }) => (
  <div className="min-h-screen bg-ice">
    <header className="bg-navy noise-overlay">
      <div className="relative z-10 mx-auto max-w-[900px] px-5 md:px-10 py-8 flex items-center justify-between">
        <Link to="/" data-testid="legal-home-link" className="flex items-center gap-3 text-ice hover:text-gold transition-colors">
          <ArrowLeft size={18} />
          <img src={LOGO_WHITE} alt="The Mailbox Brothers LLC" className="h-10 w-auto" />
        </Link>
        <a href={CONTACT.phoneHref} className="font-primary uppercase text-sm tracking-wide text-gold hover:underline">
          {CONTACT.phone}
        </a>
      </div>
    </header>

    <main className="mx-auto max-w-[900px] px-5 md:px-10 py-16 md:py-24">
      <h1 className="font-primary font-bold uppercase tracking-tighter text-navy text-4xl md:text-6xl leading-[0.9] mb-3">
        {title}
      </h1>
      <p className="font-body text-navy/50 text-sm mb-12">Last updated: {updated}</p>
      <div className="space-y-8">{children}</div>
    </main>

    <footer className="border-t border-navy/15">
      <div className="mx-auto max-w-[900px] px-5 md:px-10 py-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <p className="font-body text-navy/50 text-sm">© {new Date().getFullYear()} {CONTACT.name}</p>
        <div className="flex gap-6 font-primary uppercase text-xs tracking-widest text-navy/60">
          <Link to="/terms" className="hover:text-gold">Terms</Link>
          <Link to="/privacy" className="hover:text-gold">Privacy</Link>
          <Link to="/" className="hover:text-gold">Home</Link>
        </div>
      </div>
    </footer>
  </div>
);

export const Section = ({ heading, children }) => (
  <section>
    <h2 className="font-primary font-semibold uppercase tracking-tight text-navy text-xl md:text-2xl mb-3">{heading}</h2>
    <div className="font-body text-navy/75 text-base md:text-lg leading-relaxed space-y-3">{children}</div>
  </section>
);
